// Datos fijos del formulario de búsqueda nuevo (FormularioNuevo.vue).
//
// Los `value` son EXACTAMENTE los mismos que usa Formulario.vue y que espera
// la API en POST /intake y el motor de matching: no cambiarlos. Los textos
// visibles viven en las traducciones (formulario_nuevo.*); los nombres de
// países y ciudades que viajan en el payload se siguen sacando de
// formulario.countries.* / formulario.cities.*, igual que el formulario viejo.

import countriesData from '@/assets/data/users-countries-data.json'

// Códigos telefónicos: { code: 'AR', value: '54', name: 'Argentina (+54)' }
export const PHONE_COUNTRIES = countriesData

// Países de origen (mismo orden que Formulario.vue)
export const ORIGIN_COUNTRIES = [
    'argentina', 'chile', 'brasil', 'colombia', 'mexico', 'uruguay', 'peru',
    'espana', 'italia', 'francia', 'alemania', 'estados_unidos', 'otro',
]

// Bandera (ISO 3166-1 alfa-2) de cada clave de país. Solo decorativa.
export const COUNTRY_FLAGS = {
    argentina: 'AR', chile: 'CL', brasil: 'BR', colombia: 'CO', mexico: 'MX',
    uruguay: 'UY', peru: 'PE', espana: 'ES', italia: 'IT', francia: 'FR',
    alemania: 'DE', estados_unidos: 'US', netherlands: 'NL', austria: 'AT',
    united_kingdom: 'GB', portugal: 'PT', paraguay: 'PY',
}

// Respaldo de nombres de países que no están en formulario.countries.*
export const COUNTRY_FALLBACK = {
    netherlands: 'Netherlands', austria: 'Austria', united_kingdom: 'United Kingdom',
    portugal: 'Portugal', paraguay: 'Paraguay',
}

// Ciudades de destino agrupadas por país (mismo orden que Formulario.vue)
export const CITY_GROUPS = [
    { country: 'argentina', cities: ['buenos_aires', 'cordoba', 'mendoza', 'bariloche', 'la_plata', 'mar_del_plata', 'salta', 'neuquen'] },
    { country: 'chile', cities: ['santiago', 'valparaiso', 'vina_del_mar', 'concepcion', 'puerto_montt', 'pucon', 'villarrica'] },
    { country: 'espana', cities: ['madrid', 'barcelona', 'valencia', 'castellon_de_la_plana', 'sevilla', 'malaga', 'bilbao', 'san_sebastian', 'granada'] },
    { country: 'italia', cities: ['milan', 'rome', 'florence', 'turin', 'bologna'] },
    { country: 'alemania', cities: ['berlin', 'frankfurt', 'munich', 'dusseldorf', 'stuttgart'] },
    { country: 'francia', cities: ['paris', 'lille', 'bordeaux', 'toulouse'] },
    { country: 'netherlands', cities: ['amsterdam', 'den_haag'] },
    { country: 'austria', cities: ['vienna', 'graz'] },
    { country: 'united_kingdom', cities: ['londres'] },
    { country: 'uruguay', cities: ['montevideo', 'punta_del_este'] },
    { country: 'portugal', cities: ['lisbon', 'coimbra', 'vila_nova_de_gaia'] },
    { country: 'paraguay', cities: ['asuncion'] },
    { country: 'peru', cities: ['lima'] },
]

// Respaldo de nombres de ciudades (los que no estén en formulario.cities.*)
export const CITY_LABELS = {
    buenos_aires: 'Buenos Aires', cordoba: 'Córdoba', mendoza: 'Mendoza',
    bariloche: 'Bariloche', la_plata: 'La Plata', mar_del_plata: 'Mar del Plata',
    salta: 'Salta', neuquen: 'Neuquén', santiago: 'Santiago',
    valparaiso: 'Valparaíso', vina_del_mar: 'Viña del Mar', concepcion: 'Concepción',
    puerto_montt: 'Puerto Montt', pucon: 'Pucón', villarrica: 'Villarrica',
    madrid: 'Madrid', barcelona: 'Barcelona', valencia: 'Valencia',
    castellon_de_la_plana: 'Castellón de la Plana', sevilla: 'Sevilla',
    malaga: 'Málaga', bilbao: 'Bilbao', san_sebastian: 'San Sebastián',
    granada: 'Granada', milan: 'Milán', rome: 'Roma', florence: 'Florencia',
    turin: 'Turín', bologna: 'Bologna', berlin: 'Berlin', frankfurt: 'Frankfurt',
    munich: 'Múnich', dusseldorf: 'Düsseldorf', stuttgart: 'Stuttgart',
    paris: 'Paris', lille: 'Lille', bordeaux: 'Bordeaux', toulouse: 'Toulouse',
    amsterdam: 'Amsterdam', den_haag: 'Den Haag', vienna: 'Viena', graz: 'Graz',
    londres: 'Londres', montevideo: 'Montevideo', punta_del_este: 'Punta del Este',
    lisbon: 'Lisboa', coimbra: 'Coimbra', vila_nova_de_gaia: 'Vila Nova de Gaia',
    asuncion: 'Asunción', lima: 'Lima',
}

// Zonas por ciudad. El texto viaja tal cual en zonas_preferidas / zonas_cercanas.
export const ZONES = {
    buenos_aires: ['Palermo', 'Belgrano', 'Recoleta', 'San Telmo', 'La Boca', 'Puerto Madero', 'Almagro', 'Caballito', 'Villa Crespo', 'Flores', 'Monserrat', 'Retiro', 'Nuñez', 'Saavedra', 'Villa Urquiza', 'Chacarita', 'Colegiales', 'Boedo', 'Parque Patricios'],
    cordoba: ['Nueva Córdoba', 'Güemes', 'General Paz', 'Alberdi', 'Centro'],
    mendoza: ['Centro', 'Godoy Cruz', 'Luján de Cuyo', 'Maipú'],
    bariloche: ['Centro', 'El Nahuel', 'Melipal'],
    la_plata: ['Centro', 'City Bell', 'Villa Elisa'],
    mar_del_plata: ['Centro', 'Los Troncos', 'Playa Grande'],
    salta: ['Centro', 'Güemes', 'Tres Ceibos'],
    neuquen: ['Centro', 'Alta Barda', 'Confluencia'],
    santiago: ['Providencia', 'Ñuñoa', 'Las Condes', 'Vitacura', 'Santiago Centro'],
    valparaiso: ['Cerro Alegre', 'Plan', 'Cerro Concepción'],
    vina_del_mar: ['Centro', 'Reñaca', 'Miramar'],
    concepcion: ['Centro', 'Barrio Universitario'],
    puerto_montt: ['Centro', 'Pelluco'],
    pucon: ['Centro'],
    villarrica: ['Centro'],
    madrid: ['Chamberí', 'Salamanca', 'Retiro', 'Centro', 'Chamartín', 'Malasaña', 'Lavapiés', 'Chueca', 'Moncloa'],
    barcelona: ['Eixample', 'Gràcia', 'Sant Martí', 'Les Corts', 'Barrio Gótico', 'Poble Sec', 'Sant Gervasi'],
    valencia: ['Ruzafa', 'El Carmen', 'Benimaclet', 'Camins al Grau', 'Quatre Carreres'],
    sevilla: ['Centro', 'Triana', 'Los Remedios'],
    malaga: ['Centro', 'El Palo', 'Pedregalejo'],
    bilbao: ['Abando', 'Indautxu', 'Casco Viejo'],
    san_sebastian: ['Centro', 'Gros', 'Amara'],
    granada: ['Centro', 'Realejo', 'Albaicín'],
    montevideo: ['Centro', 'Pocitos', 'Punta Carretas'],
    punta_del_este: ['Parada 1', 'Brava', 'Peninsula'],
    asuncion: ['Centro', 'Las Mercedes', 'Villa Morra'],
    lima: ['Miraflores', 'San Isidro', 'Barranco'],
}

export const PROGRAMS = ['intercambio', 'pasantia', 'master', 'trabajo', 'otro']

// `tipo` y `categoria` son los que usa el motor de matching (iguales a Formulario.vue).
export const ACCOMMODATION = [
    { value: 'monoambiente', icon: 'studio', tipo: 'entero', categoria: 'departamento' },
    { value: 'habitacion_privada', icon: 'bed', tipo: 'privado', categoria: ['departamento', 'casa', 'residencia'] },
    { value: 'coliving', icon: 'people', tipo: 'privado', categoria: 'residencia' },
    { value: 'depto_1d', icon: 'building', tipo: 'entero', categoria: 'departamento' },
    { value: 'depto_2d', icon: 'buildings', tipo: 'entero', categoria: 'departamento' },
    { value: 'indiferente', icon: 'sparkle' }, // sin tipo ni categoría: no filtra
]

export const PEOPLE = [1, 2, 3, 4]

export const URGENCY = [
    { value: 'urgente', tone: 'hot' },
    { value: 'pronto', tone: 'warm' },
    { value: 'explorando', tone: 'cool' },
]

// Íconos de las tarjetas de alojamiento (SVG en línea, sin datos del usuario).
export const ICONS = {
    studio: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/><path d="M9 21v-6h6v6"/></svg>',
    bed: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 18V6M21 18v-5a3 3 0 0 0-3-3H10v8"/><path d="M3 14h18M3 18h18"/><circle cx="6.5" cy="11" r="1.6"/></svg>',
    people: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="8" r="3.2"/><path d="M3 20a6 6 0 0 1 12 0"/><circle cx="17" cy="9" r="2.5"/><path d="M16 14.2A5 5 0 0 1 21 19"/></svg>',
    building: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="3" width="14" height="18" rx="1.5"/><path d="M9 7h2M13 7h2M9 11h2M13 11h2M9 15h2M13 15h2M10 21v-3h4v3"/></svg>',
    buildings: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="7" width="9" height="14" rx="1.2"/><path d="M12 10h7.8a1.2 1.2 0 0 1 1.2 1.2V21H12"/><path d="M6 11h3M6 14.5h3M6 18h3M15 14h3M15 17.5h3M7.5 7V3h4"/></svg>',
    sparkle: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="6.5"/><path d="m20.5 20.5-4.8-4.8"/><path d="M11 8v6M8 11h6"/></svg>',
}

// Pasos y campos de cada uno (para validar y para la barra de progreso).
export const TOTAL_STEPS = 5
export const STEP_FIELDS = {
    1: ['nombre', 'email', 'whatsapp', 'pais_origen', 'edad'],
    2: ['programa', 'universidad', 'universidad_destino', 'ciudad', 'zonas_preferidas', 'zonas_cercanas', 'fecha_inicio', 'fecha_fin'],
    3: ['tipo_alojamiento', 'cantidad_personas', 'va_en_pareja'],
    4: ['presupuesto', 'urgencia', 'en_ciudad', 'tiene_pasajes'],
    5: ['partner_nombre'],
}

// Formulario vacío. Mismos campos que Formulario.vue más phone_country /
// phone_code (el viejo guardaba el país del teléfono fuera de `form`).
export function emptyForm() {
    return {
        nombre: '', email: '', phone_country: '', phone_code: '', whatsapp: '',
        pais_origen: '', edad: '',
        programa: '', universidad: '', universidad_destino: '', ciudad: '',
        zonas_preferidas: [], zonas_cercanas: [], fecha_inicio: '', fecha_fin: '',
        tipo_alojamiento: '', tipo_alojamiento_tipo: '', tipo_alojamiento_categoria: null,
        cantidad_personas: 1, va_en_pareja: null,
        presupuesto: '', urgencia: '', en_ciudad: null, tiene_pasajes: null,
        referido: false, partner_nombre: '', partner_otro: false, comentario: '',
        meta: null,
    }
}

// Lleva un progreso guardado (puede venir del formulario viejo, con null en
// los textos) a la forma que espera este formulario.
export function normalizeForm(saved) {
    const f = Object.assign(emptyForm(), saved || {})
    ;['nombre', 'email', 'phone_country', 'phone_code', 'whatsapp', 'pais_origen', 'programa',
        'universidad', 'universidad_destino', 'ciudad', 'fecha_inicio', 'fecha_fin',
        'tipo_alojamiento', 'tipo_alojamiento_tipo', 'urgencia', 'partner_nombre', 'comentario',
    ].forEach((k) => { f[k] = f[k] == null ? '' : String(f[k]) })
    f.whatsapp = f.whatsapp.replace(/\D/g, '')
    if (f.edad === null || f.edad === undefined) f.edad = ''
    if (f.presupuesto === null || f.presupuesto === undefined) f.presupuesto = ''
    if (!Array.isArray(f.zonas_preferidas)) f.zonas_preferidas = []
    if (!Array.isArray(f.zonas_cercanas)) f.zonas_cercanas = []
    if (!PEOPLE.includes(Number(f.cantidad_personas))) f.cantidad_personas = 1
    else f.cantidad_personas = Number(f.cantidad_personas)
    f.partner_otro = f.partner_otro === true
    return f
}
